<template>
  <q-icon :name="iconName" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { isImage, isVideo } from '.';

export default defineComponent({
  props: {
    fileName: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconName(): string {
      if (isImage(this.fileName)) return 'fa fa-file-image';
      if (isVideo(this.fileName)) return 'fa fa-file-video';
      return 'fa fa-file';
    },
  },
});
</script>
